import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

interface LinkItem {
  label: string;
  to: string;
}

interface DropdownLinksProps {
  links: LinkItem[];
  buttonTitle: string;
}

const FooterLinks: React.FC<DropdownLinksProps> = ({ links, buttonTitle }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLgScreen, setIsLgScreen] = useState(false);

  // Détecte la taille d'écran
  useEffect(() => {
    const handleResize = () => {
      setIsLgScreen(window.innerWidth >= 1024);
    };

    handleResize(); // Vérifie la taille initiale
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const toggleDropdown = () => {
    if (!isLgScreen) {
      setIsOpen(!isOpen);
    }
  };

  return (
    <div className="relative">
      {/* Bouton principal */}
      <button
        onClick={toggleDropdown}
        className={`text-secondary-blue font-bold ${
          isLgScreen ? "cursor-default" : ""
        } flex items-center justify-between w-full`}
      >
        {buttonTitle}
        <span>
          <img
            src="/assets/images/vecteurs/chevron-down-blue.svg"
            alt="chevrons"
            className="w-4  lg:hidden"
          />
        </span>
      </button>

      {/* Liste déroulante */}
      <ul
        className={`transition-all duration-300 ease-in-out overflow-hidden ${
          isOpen || isLgScreen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        } bg-white`}
      >
        {links.map((link, index) => (
          <li key={index}>
            <Link to={link.to} className="block py-2 text-black">
              <span>{link.label}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FooterLinks;
